"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostButtonLink = exports.GhostButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const primary_1 = require("./primary");
exports.GhostButton = (0, styled_1.default)(primary_1.PrimaryButton) `
  &&& {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
    color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_text')};

    &:focus {
      background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
      outline-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
      outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
      outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
      outline-offset: 0;
    }

    &:hover {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
      color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover_text')};
    }

    &:active:not(:disabled) {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
      color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover_text')};

      outline-color: ${(0, ui_theme_1.fromTheme)('color_button')};
      outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
      outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
      outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
    }

    &:disabled {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
      color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
      cursor: not-allowed;
    }
  }
`;
exports.GhostButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.GhostButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=ghost.js.map